import { render, staticRenderFns } from "./SelectUserExtension.vue?vue&type=template&id=7ec1b4fb&scoped=true&"
import script from "./SelectUserExtension.vue?vue&type=script&lang=js&"
export * from "./SelectUserExtension.vue?vue&type=script&lang=js&"
import style0 from "./SelectUserExtension.vue?vue&type=style&index=0&id=7ec1b4fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1b4fb",
  null
  
)

export default component.exports